import BybButtonVR from "@Components/game/common/buttons/byb-button/byb-button-vr";
import { BybVrMenuItem, BybVrSelect } from "@Components/game/common/byb-vr-select";
import { useProgress } from "@Context/game/progress/progress-context";
import DateRange from "@Enums/DateRange";
import { faPlay } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { FormControl, Stack, Typography, useTheme } from "@mui/material";

const ProgressHeader = () => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const {
    dateRange,
    setDateRange,
    isInBootcamp,
    nextBootcampChallenge,
    isLoadingNextChallenge,
    navigateToNextChallenge,
    isDemo,
    navigateToChallenges,
  } = useProgress();

  return (
    <Stack width="100%" paddingTop={theme.spacing(22)} paddingBottom={theme.spacing(2)} textAlign={"center"} alignItems={"center"} gap={2}>
      <Typography variant="text7xl800" color="dsBase.v200">
        {i18n("your.progress")}
      </Typography>
      <Typography variant="text1xl400" color="dsBase.v200" width={"50%"}>
        {isDemo ? i18n("progress.description") : isInBootcamp ? i18n("progress.bootcamp.description") : i18n("progress.description")}
      </Typography>
      {isDemo && (
        <>
          <Typography variant="text1xl400" color="dsBase.v200" width={"50%"}>
            {i18n("progress.demo.cta")}
          </Typography>
          <Stack width="100%" alignItems="center" gap={2} paddingY={theme.spacing(6)}>
            <BybButtonVR icon={faPlay} onClick={navigateToChallenges}>
              {i18n("progress.demo.button")}
            </BybButtonVR>
          </Stack>
        </>
      )}
      {!isDemo && isInBootcamp && (
        <>
          <Typography variant="text1xl400" color="dsBase.v200" width={"50%"}>
            {i18n("progress.bootcamp.cta")}
          </Typography>
          <Stack width="100%" alignItems="center" gap={2} paddingY={theme.spacing(6)}>
            <BybButtonVR icon={faPlay} onClick={navigateToNextChallenge} disabled={!nextBootcampChallenge} loading={isLoadingNextChallenge}>
              {i18n("progress.bootcamp.button")}
            </BybButtonVR>
          </Stack>
        </>
      )}
      {!isDemo && !isInBootcamp && (
        <FormControl sx={{ marginTop: theme.spacing(2) }}>
          <BybVrSelect
            value={dateRange}
            onChange={(event: any) => setDateRange(event.target.value as DateRange)}
            MenuProps={{
              PaperProps: {
                elevation: 0,
                sx: {
                  backdropFilter: `blur(${theme.spacing(0.5)})`,
                  backgroundColor: `${theme.palette.dsSurface.v100}80`,
                  border: `1px solid ${theme.palette.dsSurface.v400}80`,
                  boxShadow: "none",
                  borderRadius: theme.spacing(1),
                },
              },
              MenuListProps: {
                sx: {
                  backgroundColor: `${theme.palette.dsSurface.v100}80`,
                  borderRadius: theme.spacing(1),
                  padding: theme.spacing(0.5),
                  width: "15vw",
                  "& .MuiMenuItem-root:hover": {
                    backgroundColor: theme.palette.dsSurface.v200,
                  },
                  "& .MuiMenuItem-root.Mui-selected": {
                    backgroundColor: "transparent !important",
                  },
                  "& .MuiMenuItem-root.Mui-selected:hover": {
                    backgroundColor: `${theme.palette.dsSurface.v200} !important`,
                  },
                  "& .MuiMenuItem-root.Mui-selected.Mui-focusVisible": {
                    backgroundColor: "transparent",
                  },
                },
              },
            }}
            sx={{
              "& .MuiSelect-select": {
                fontSize: theme.typography.textBase600.fontSize,
                padding: `${theme.spacing(1.5)} ${theme.spacing(6)} ${theme.spacing(1.5)} ${theme.spacing(2.5)}`,
                backdropFilter: `blur(${theme.spacing(1.25)})`,
                backgroundColor: `${theme.palette.dsSurface.v100}80`,
                border: `1px solid ${theme.palette.dsSurface.v400}80`,
                "&:hover": {
                  backgroundColor: `${theme.palette.dsSurface.v100}CC`,
                  borderColor: `${theme.palette.dsSurface.v400}CC`,
                },
              },
            }}
          >
            <BybVrMenuItem value={DateRange.PAST_14_DAYS}>{i18n("progress.section.progress.past_14_days")}</BybVrMenuItem>
            <BybVrMenuItem value={DateRange.PAST_MONTH}>{i18n("progress.section.progress.past_month")}</BybVrMenuItem>
            <BybVrMenuItem value={DateRange.PAST_3_MONTHS}>{i18n("progress.section.progress.past_3_months")}</BybVrMenuItem>
            <BybVrMenuItem value={DateRange.PAST_YEAR}>{i18n("progress.section.progress.past_year")}</BybVrMenuItem>
            <BybVrMenuItem value={DateRange.ALL_TIME}>{i18n("progress.section.progress.all_time")}</BybVrMenuItem>
          </BybVrSelect>
        </FormControl>
      )}
    </Stack>
  );
};

export default ProgressHeader;
